import { AxiosResponse } from 'axios';
import { Dayjs } from 'dayjs';
import { Subject } from 'rxjs';

const subject = new Subject();

const EtcUtils = {
  download(response: AxiosResponse, fName?: string) {
    const dis = response.headers['content-disposition'];
    const regex = /fileName="(?<filename>[^"]+)"/;

    let filename = fName ? fName : '파일.xlsx';
    if (dis) {
      const match = dis.match(regex);
      filename = decodeURIComponent(match[1]);
    }

    const downloadUrl = window.URL.createObjectURL(response.data);
    const anchorElement = document.createElement('a');
    document.body.appendChild(anchorElement);
    anchorElement.download = filename;
    anchorElement.href = downloadUrl;

    anchorElement.click();

    document.body.removeChild(anchorElement);
  },
  setEvent(eventname: EVENT_LIST, _detail: any) {
    if (typeof eventname !== 'undefined' && !eventname) throw new Error('undefined eventname');
    return new CustomEvent(eventname, {
      detail: _detail,
    });
  },
  hasKeys(obj: Object, keysArray: Array<string>) {
    for (const key of keysArray) {
      if (!Object.prototype.hasOwnProperty.call(obj, key)) {
        return false;
      }
    }
    return true;
  },
  dayjsTransToString(day: Dayjs, format = 'MMDD') {
    return day.format(format);
  },
  observer: {
    mapInteraction: {
      clickCallback: (message: any, type?: string) => subject.next({ type: type, message: message }),
      subject: subject,
    },
    cellInteraction: {
      openCallback: (message: any) => subject.next({ type: 'OPEN', message: message }),
      editCallback: (message: any) => subject.next({ type: 'EDIT', message: message }),
      closeCellEdit: (message: number) => subject.next({ type: 'CLOSE', message: message }),
      deleteCallback: (message: any) => subject.next({ type: 'DELETE', message: message }),
      addCallback: (message: any) => subject.next({ type: 'ADD', message: message }),
      subject: subject,
    },
  },
};

type MessageType = {};

type EVENT_LIST = 'REPORT/LIST/DELETE' | 'REPORT/LIST/UPDATE' | 'REPORT/LIST/EDITOR/OPEN' | 'ALARM/VIEW';

export default EtcUtils;
